import React, { useState, useContext } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import InputAdornment from "@material-ui/core/InputAdornment";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";

import AlertMui from "../core/AlertMui";
import AlertContext from "../../context/alert/alertContext";
import AuthContext from "../../context/authentication/authContext";

const ForgotPassword = ({ classes }) => {
  const alertContext = useContext(AlertContext);
  const authContext = useContext(AuthContext);
  const { alert, showAlert } = alertContext;
  const { forgotPassword } = authContext;

  const [user, setUser] = useState({
    username: "",
  });

  const { username } = user;

  const onChange = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  //submit form
  const onSubmit = async (e) => {
    e.preventDefault();

    //validate empty fields
    if (username.trim() === "") {
      showAlert("Todos los campos son obligatorios.", "warning");
      return;
    }

    let data = {
      username,
    };

    try {
      const response = await forgotPassword(data);
      //console.log(response)
      if (response.responseCode === 0) {
        showAlert(response.responseMessage);
      } else {
        showAlert(response.responseMessage, "error");
      }
    } catch (error) {
      showAlert("Ha ocurrido un error inesperado", "error");
    }
  };

  return (
    <form className={classes.form} noValidate onSubmit={onSubmit}>
      <TextField
        margin="normal"
        fullWidth
        id="username"
        label="RUT USUARIO"
        name="username"
        autoComplete="username"
        autoFocus
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailOutlinedIcon
                style={{
                  color: "#12b1ee",
                }}
              />
            </InputAdornment>
          ),
        }}
        onChange={onChange}
      />
      <Grid className={classes.contentSubmit}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.submit}
        >
          RECUPERAR CONTRASEÑA
        </Button>
      </Grid>
      {alert && <AlertMui message={alert.msg} type={alert.category} />}
    </form>
  );
};

export default ForgotPassword;
